import bonusById from './bonusById';

export default bonusById;
